module.exports = __webpack_public_path__ + "static/img/son3_active.c766edc4.png";